import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { HubLogoModule } from '../hub-logo/hub-logo.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { HubNavComponent } from './hub-nav.component';
import { NotificationsModule } from '../notifications/notifications.module';
import { FirstNamePipeModule } from '../../pipes';
import { IfCblcDirectiveModule } from '../../directives/if-cblc/if-cblc.module';
import { TrackingDirectiveModule } from '../../directives/tracking/tracking.module';
import { HubBaseRegistrationModule } from '../hub-base-registration/hub-base-registration.module';
import { RewardsGiftButtonModule } from '@toro/common/shared/components/rewards-gift-button/rewards-gift-button.module';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        HubLogoModule,
        SvgIconModule,
        NotificationsModule,
        FirstNamePipeModule,
        IfCblcDirectiveModule,
        TrackingDirectiveModule,
        HubBaseRegistrationModule,
        RewardsGiftButtonModule,
    ],
    declarations: [ HubNavComponent ],
    exports: [ HubNavComponent ],
})
export class HubNavModule { }
